const PREVIEW_MIMES = new Set([
  "application/pdf", "image/png", "image/jpeg", "image/webp", "image/gif", "image/bmp", "image/avif",
]);
const MAX_BYTES = 6 * 1024 * 1024;

// A stored document is data, never a navigation URL or executable markup.
export function documentPreviewBlob(file) {
  const mime = String(file?.mime || "").toLowerCase();
  if (!PREVIEW_MIMES.has(mime)) throw new Error("Formato non visualizzabile: usa un PDF o un'immagine PNG, JPEG, WebP, GIF, BMP o AVIF.");
  let encoded = String(file?.data_base64 || "");
  if (encoded.startsWith("data:")) {
    const match = encoded.match(/^data:([^;,]+);base64,([\s\S]*)$/);
    if (!match || match[1].toLowerCase() !== mime) throw new Error("Formato del documento non coerente.");
    encoded = match[2];
  }
  encoded = encoded.replace(/\s/g, "");
  if (!encoded || encoded.length > Math.ceil(MAX_BYTES / 3) * 4 || !/^[A-Za-z0-9+/]*={0,2}$/.test(encoded)) {
    throw new Error("Documento non valido o troppo grande (massimo 6 MB).");
  }
  let decoded;
  try { decoded = atob(encoded); } catch { throw new Error("Documento non valido (base64)."); }
  if (!decoded.length || decoded.length > MAX_BYTES) throw new Error("Documento non valido o troppo grande (massimo 6 MB).");
  return new Blob([Uint8Array.from(decoded, (character) => character.charCodeAt(0))], { type: mime });
}
